import { render, staticRenderFns } from "./LowCodeSection.vue?vue&type=template&id=22f34003&"
import script from "./LowCodeSection.vue?vue&type=script&lang=js&"
export * from "./LowCodeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports